import DashboardLayout from "../../components/Table/Dashboard/DashboardLayout";
import { AllOrgsDashboardProvider } from "../../context/SuperAdmin/DashboardContexts/AllOrganizations";
import { AllSuborgsDashboardProvider } from "../../context/SuperAdmin/DashboardContexts/AllSuborgs";
import { AllSuscripsDashboardProvider } from "../../context/SuperAdmin/DashboardContexts/AllSuscriptions";
import { AllUsersDashboardProvider } from "../../context/SuperAdmin/DashboardContexts/AllUsers";
import { MainDashboardLayoutProvider } from "../../context/SuperAdmin/DashboardContexts/MainDashboardLayout";
import { SingleOrgDashboardProvider } from "../../context/SuperAdmin/DashboardContexts/SingleOrg";
import { OrganizationProvider } from "../../context/SuperAdmin/OrganizationContext";
import { PlanProvider } from "../../context/SuperAdmin/PlanContext";
import { RolesProvider } from "../../context/SuperAdmin/RolesContext";
import { SinglePlanProvider } from "../../context/SuperAdmin/SinglePlanContext";
import { SingleRoleProvider } from "../../context/SuperAdmin/SingleRoleContext";
import { SingleSuscriptProvider } from "../../context/SuperAdmin/SingleSuscriptContext";
import { SuscriptsProvider } from "../../context/SuperAdmin/SuscriptsContext";
import { SingleOrganizationProvider } from "../../context/SuperAdmin/SingleOrgContext";
import { UsersProvider } from "../../context/SuperAdmin/UsersContext";
import { UserSuscriptionProvider } from "../../context/SuperAdmin/UserSuscriptionContext";
import { PagePermissions } from "../../data/roles";
import { iRoute } from "../../interfaces/Route";
import { AdminPage } from "../../pages/AdminPage";
import AuditoriasPage from "../../pages/SuperAdmin/AuditoriasPage";
import CreateRole from "../../pages/SuperAdmin/CreateRole";
import AllOrgsDashboard from "../../pages/SuperAdmin/Dashboards/AllOrgs";
import AllSuborgsDashboard from "../../pages/SuperAdmin/Dashboards/AllSuborgs";
import AllSuscriptionsDashboard from "../../pages/SuperAdmin/Dashboards/AllSuscriptions";
import AllUsersDashboard from "../../pages/SuperAdmin/Dashboards/AllUsers";
import SingleOrgDashboard from "../../pages/SuperAdmin/Dashboards/SingleOrg";
import SingleSuborgDashboard from "../../pages/SuperAdmin/Dashboards/SingleSuborg";
import SingleSuscrDashboard from "../../pages/SuperAdmin/Dashboards/SingleSuscription";
import SingleUserDahsboard from "../../pages/SuperAdmin/Dashboards/SingleUser";
import { OrganizationPage } from "../../pages/SuperAdmin/OrganizationPage";
import PlansPage from "../../pages/SuperAdmin/PlansPage";
import RolesPage from "../../pages/SuperAdmin/RolesPage";
import { SingleOrgPage } from "../../pages/SuperAdmin/SingleOrgPage";
import SinglePlanPage from "../../pages/SuperAdmin/SinglePlanPage";
import SingleRolePage from "../../pages/SuperAdmin/SingleRolePage";
import SingleSuborgPage from "../../pages/SuperAdmin/SingleSuborgPage";
import SingleSuscriptCreditPage from "../../pages/SuperAdmin/SingleSuscriptCreditPage";
import SingleSuscriptPage from "../../pages/SuperAdmin/SingleSuscriptPage";
import SuscriptionsPage from "../../pages/SuperAdmin/SuscriptionsPage";
import UsersPage from "../../pages/SuperAdmin/UsersPage";
import UserSuscriptionPage from "../../pages/SuperAdmin/UserSuscriptionsPage";
import ProtectedAuditoriaRoute from "../ProtectedAuditoriaRoute";
import ProtectedOrgRoute from "../ProtectedOrgRoutes";
import { SingleSuborgProvider } from "../../context/SuperAdmin/SingleSuborgContext";
import { UserControlProvider } from "../../context/SuperAdmin/UserControlContext";
import UserContolPage from "../../pages/SuperAdmin/UserContolPage";
import { SingleUserControlProvider } from "../../context/SuperAdmin/SingleUserControlContext";
import SingleUserControlPage from "../../pages/SuperAdmin/SingleUserControlPage";
import OASPage from "../../pages/SuperAdmin/OASPage";
import TiposPage from "../../pages/SuperAdmin/OAS/TiposPage";
import NivelesPage from "../../pages/SuperAdmin/OAS/NivelesPage";
import AsignaturasPage from "../../pages/SuperAdmin/OAS/AsignaturasPage";
import ObjetivosPage from "../../pages/SuperAdmin/OAS/ObjetivosPage";
import MenuPage from "../../pages/SuperAdmin/OAS/MenuPage";
import { OASProvider } from "../../context/SuperAdmin/OASContexts/OASContext";
import { TiposProvider } from "../../context/SuperAdmin/OASContexts/TiposContext";
import { NivelesProvider } from "../../context/SuperAdmin/OASContexts/NivelesContext";
import { AsignaturasProvider } from "../../context/SuperAdmin/OASContexts/AsignaturasContext";
import { ObjetivosProvider } from "../../context/SuperAdmin/OASContexts/ObjetivosContext";
import { SingleNivelProvider } from "../../context/SuperAdmin/OASContexts/SingleNivelContext";
import SingleNivelPage from "../../pages/SuperAdmin/OAS/SingleNivelPage";
import { CreateObjetivoProvider } from "../../context/SuperAdmin/OASContexts/CreateObjetivoContext";
import CreateObjetivo from "../../pages/SuperAdmin/OAS/CreateObjetivo";
import { SingleObjetivoProvider } from "../../context/SuperAdmin/OASContexts/SingleObjetivoContext";
import SingleObjetivoPage from "../../pages/SuperAdmin/OAS/SingleObjetivoPage";

interface SARoute extends iRoute {
  permission: PagePermissions | PagePermissions[];
}

interface SARouteChildren extends SARoute {
  children?: SARoute[];
}

export const superAdminRoutes: SARouteChildren[] = [
  {
    path: "organizations",
    element: (
      <ProtectedOrgRoute
        Wrapper={OrganizationProvider}
        Component={OrganizationPage}
      />
    ),
    permission: "view:organization",
  },
  {
    path: "organizations/:idOrganization",
    element: (
      <ProtectedOrgRoute
        Wrapper={SingleOrganizationProvider}
        Component={SingleOrgPage}
      />
    ),
    permission: ["view:organization", "view:ownOrganization"],
  },
  {
    path: "organizations/:idOrganization/suborganizations/:idSuborganization",
    element: (
      <ProtectedOrgRoute
        Wrapper={SingleSuborgProvider}
        Component={SingleSuborgPage}
      />
    ),
    permission: ["view:organization", "view:ownOrganization"],
  },
  {
    path: "roles",
    element: (
      <ProtectedOrgRoute Wrapper={RolesProvider} Component={RolesPage} />
    ),
    permission: "view:roles",
  },
  {
    path: "roles/:idOrganization",
    element: (
      <ProtectedOrgRoute Wrapper={RolesProvider} Component={RolesPage} />
    ),
    permission: ["view:roles", "view:ownRoles"],
  },
  {
    path: "roles/:idOrganization/:idRol",
    element: (
      <ProtectedOrgRoute
        Wrapper={SingleRoleProvider}
        Component={SingleRolePage}
      />
    ),
    permission: ["view:roles", "view:ownRoles"],
  },
  {
    path: "roles/:idOrganization/create",
    element: <ProtectedOrgRoute Component={CreateRole} />,
    permission: "create:role",
  },
  {
    path: "plans",
    element: <ProtectedOrgRoute Wrapper={PlanProvider} Component={PlansPage} />,
    permission: "view:plans",
  },
  {
    path: "plans/:idOrganization",
    element: <ProtectedOrgRoute Wrapper={PlanProvider} Component={PlansPage} />,
    permission: ["view:plans", "view:ownPlans"],
  },
  {
    path: "plans/:idOrganization/:idPlan",
    element: (
      <ProtectedOrgRoute
        Wrapper={SinglePlanProvider}
        Component={SinglePlanPage}
      />
    ),
    permission: ["view:plans", "view:ownPlans"],
  },
  {
    path: "suscriptions",
    element: (
      <ProtectedOrgRoute
        Wrapper={SuscriptsProvider}
        Component={SuscriptionsPage}
      />
    ),
    permission: "view:suscriptions",
  },
  {
    path: "suscriptions/:idOrganization",
    element: (
      <ProtectedOrgRoute
        Wrapper={SuscriptsProvider}
        Component={SuscriptionsPage}
      />
    ),
    permission: ["view:suscriptions", "view:ownSuscriptions"],
  },
  {
    path: "suscriptions/:idOrganization/:idSuscription",
    element: (
      <ProtectedOrgRoute
        Wrapper={SingleSuscriptProvider}
        Component={SingleSuscriptPage}
      />
    ),
    permission: ["view:suscriptions", "view:ownSuscriptions"],
  },
  {
    path: "suscriptions/:idOrganization/:idSuscription/credits",
    element: (
      <ProtectedOrgRoute
        Wrapper={SingleSuscriptProvider}
        Component={SingleSuscriptCreditPage}
      />
    ),
    permission: ["view:suscriptions", "view:ownSuscriptions"],
  },
  {
    path: "users",
    element: (
      <ProtectedOrgRoute Wrapper={UsersProvider} Component={UsersPage} />
    ),
    permission: "view:users",
  },
  {
    path: "users/:idOrganization",
    element: (
      <ProtectedOrgRoute Wrapper={UsersProvider} Component={UsersPage} />
    ),
    permission: ["view:users", "view:ownUsers"],
  },
  {
    path: "users/:idOrganization/:idUser",
    element: (
      <ProtectedOrgRoute
        Wrapper={UserSuscriptionProvider}
        Component={UserSuscriptionPage}
      />
    ),
    permission: "view:userSuscriptions",
  },
  {
    path: "auditorias/:tipoAuditoria/:orgOrPais",
    element: <ProtectedAuditoriaRoute Component={AuditoriasPage} />,
    permission: "view:reports",
  },
  {
    path: "auditorias/:tipoAuditoria/:orgOrPais/:idPaisOrOrg",
    element: <ProtectedAuditoriaRoute Component={AuditoriasPage} />,
    permission: ["view:reports", "view:ownReports"],
  },
  {
    path: "admin",
    element: <AdminPage />,
    permission: "view:admin",
  },
  {
    path: "dashboard",
    element: (
      <ProtectedOrgRoute
        Wrapper={MainDashboardLayoutProvider}
        Component={DashboardLayout}
      />
    ),
    permission: ["view:dashboard", "view:ownDashboard"],
    children: [
      {
        path: "organizations",
        element: (
          <ProtectedOrgRoute
            Wrapper={AllOrgsDashboardProvider}
            Component={AllOrgsDashboard}
          />
        ),
        permission: "view:dashboard",
      },
      {
        path: ":idOrganization/organization",
        element: (
          <ProtectedOrgRoute
            Wrapper={SingleOrgDashboardProvider}
            Component={SingleOrgDashboard}
          />
        ),
        permission: ["view:dashboard", "view:ownDashboard"],
      },
      {
        path: ":idOrganization/suscriptions",
        element: (
          <ProtectedOrgRoute
            Wrapper={AllSuscripsDashboardProvider}
            Component={AllSuscriptionsDashboard}
          />
        ),
        permission: ["view:dashboard", "view:ownDashboard"],
      },
      {
        path: ":idOrganization/suscriptions/:idSuscription",
        element: (
          <ProtectedOrgRoute
            Wrapper={AllSuscripsDashboardProvider}
            Component={SingleSuscrDashboard}
          />
        ),
        permission: ["view:dashboard", "view:ownDashboard"],
      },
      {
        path: ":idOrganization/users",
        element: (
          <ProtectedOrgRoute
            Wrapper={AllUsersDashboardProvider}
            Component={AllUsersDashboard}
          />
        ),
        permission: ["view:dashboard", "view:ownDashboard"],
      },
      {
        path: ":idOrganization/users/:idUser",
        element: (
          <ProtectedOrgRoute
            Wrapper={AllUsersDashboardProvider}
            Component={SingleUserDahsboard}
          />
        ),
        permission: ["view:dashboard", "view:ownDashboard"],
      },
      {
        path: ":idOrganization/suborganizations",
        element: (
          <ProtectedOrgRoute
            Wrapper={AllSuborgsDashboardProvider}
            Component={AllSuborgsDashboard}
          />
        ),
        permission: ["view:dashboard", "view:ownDashboard"],
      },
      {
        path: ":idOrganization/suborganizations/:idSuborg",
        element: (
          <ProtectedOrgRoute
            Wrapper={AllSuborgsDashboardProvider}
            Component={SingleSuborgDashboard}
          />
        ),
        permission: ["view:dashboard", "view:ownDashboard"],
      },
    ],
  },
  {
    path: "allusers",
    element: (
      <UserControlProvider>
        <UserContolPage />
      </UserControlProvider>
    ),
    permission: "view:users",
  },
  {
    path: "allusers/:idUser",
    element: (
      <SingleUserControlProvider>
        <SingleUserControlPage />
      </SingleUserControlProvider>
    ),
    permission: "view:users",
  },
  {
    path: "oas",
    element: <ProtectedOrgRoute Wrapper={OASProvider} Component={OASPage} />,
    permission: "view:oas",
  },
  {
    path: "oas/:idOrganization",
    element: <ProtectedOrgRoute Wrapper={OASProvider} Component={OASPage} />,
    permission: ["view:oas", "view:ownOas"],
    children: [
      {
        path: "",
        element: <ProtectedOrgRoute Component={MenuPage} />,
        permission: ["view:oas", "view:ownOas"],
      },
      {
        path: "tipos",
        element: (
          <ProtectedOrgRoute Wrapper={TiposProvider} Component={TiposPage} />
        ),
        permission: ["view:oas", "view:ownOas"],
      },
      {
        path: "niveles",
        element: (
          <ProtectedOrgRoute
            Wrapper={NivelesProvider}
            Component={NivelesPage}
          />
        ),
        permission: ["view:oas", "view:ownOas"],
      },
      {
        path: "niveles/:idNivel",
        element: (
          <ProtectedOrgRoute
            Wrapper={SingleNivelProvider}
            Component={SingleNivelPage}
          />
        ),
        permission: ["view:oas", "view:ownOas"],
      },
      {
        path: "asignaturas",
        element: (
          <ProtectedOrgRoute
            Wrapper={AsignaturasProvider}
            Component={AsignaturasPage}
          />
        ),
        permission: ["view:oas", "view:ownOas"],
      },
      {
        path: "objetivos",
        element: (
          <ProtectedOrgRoute
            Wrapper={ObjetivosProvider}
            Component={ObjetivosPage}
          />
        ),
        permission: ["view:oas", "view:ownOas"],
      },
      {
        path: "objetivos/create",
        element: (
          <ProtectedOrgRoute
            Wrapper={CreateObjetivoProvider}
            Component={CreateObjetivo}
          />
        ),
        permission: ["view:oas", "view:ownOas"],
      },
      {
        path: "objetivos/:idObjetivo",
        element: (
          <ProtectedOrgRoute
            Wrapper={SingleObjetivoProvider}
            Component={SingleObjetivoPage}
          />
        ),
        permission: ["view:oas", "view:ownOas"],
      },
    ],
  },
];
